import { render, staticRenderFns } from "./SearchTemplate.vue?vue&type=template&id=66b6e96e&"
import script from "./SearchTemplate.vue?vue&type=script&lang=js&"
export * from "./SearchTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports